import _Message from "@mui/icons-material/Message";
import React from 'react';
import { COLORS } from '@fupa/fupa-uikit';
import { Heading, IconContainer, LinkContainer, LinkText, PresentedClaim, StyledLink, Subtitle, Title, Wrapper } from 'app/components/styles/districtModules/headerStyles';
import { SiteSponsoring, useSiteSponsoring } from 'app/components/partner/SiteSponsoring';
import styled from 'styled-components';
const SCSiteSponsoring = styled(SiteSponsoring).withConfig({
  componentId: "sc-16f0d1t-0"
})(["&&&{display:flex;margin-left:0.5rem;@media (max-width:359px){display:none;}}"]);
const SCSubtitle = styled(Subtitle).withConfig({
  componentId: "sc-16f0d1t-1"
})(["display:", ";@media (max-width:359px){display:block;}"], _ref => {
  let {
    sponsoring
  } = _ref;
  return sponsoring ? 'none' : 'block';
});
export default function TopNewsHeader(_ref2) {
  let {
    pathname
  } = _ref2;
  const {
    hasSponsoring
  } = useSiteSponsoring();
  const sponsoringElement = hasSponsoring ? /*#__PURE__*/React.createElement(SCSiteSponsoring, {
    className: "",
    withClaim: false
  }) : null;
  const subtitle = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PresentedClaim, {
    sponsoring: hasSponsoring,
    variant: "caption1"
  }, "pr\xE4sentiert von"), /*#__PURE__*/React.createElement(SCSubtitle, {
    sponsoring: hasSponsoring,
    variant: "caption3"
  }, "Alles Wichtige auf einen Blick"));
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TopNewsHeader",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.darkGreen,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Message, {
    color: "icon-invert",
    fontSize: "inherit",
    "data-sentry-element": "Message",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  })), /*#__PURE__*/React.createElement(Heading, {
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, "Top-Meldungen"), subtitle), sponsoringElement, pathname ? /*#__PURE__*/React.createElement(LinkContainer, null, /*#__PURE__*/React.createElement(StyledLink, {
    to: "".concat(pathname, "/news"),
    decoration: "underline"
  }, /*#__PURE__*/React.createElement(LinkText, {
    variant: "caption3"
  }, 'Alle Meldungen >'))) : null);
}